import { Card as TCard } from "@trackier/cloudstuff-ui";
import classNames from "classnames";
import size from "lodash/size";
const Card = ({
    children,
    header = null, 
    footer = <></>,
    headerClass = "",
    footerClass = "",
    bodyClass = "",
    containerClass = "",
    ...props
}) => {
    return (
        <TCard
            {...(header ? { header } : {})} // Add the header prop only if it exists
            footer={footer}
            containerClass={classNames(
                "bg-white w-full d-flex card mt-1",
                containerClass
            )}
            headerClass={classNames({ [headerClass]: headerClass,
                "card-header": size(header)
            })}
            footerClass={footerClass}
            bodyClass={classNames("card-body", bodyClass)}
            {...props}>
            {children}
        </TCard>

    );
};

export default Card;